import { createStyle } from '@gluestack-style/react';

export const LinkText = createStyle({
  textDecorationLine: 'none',
  color: '$black',
  _dark: {
    color: '$white',
  },
});
